<ng-container *ngIf="!isLoading && formData">
  <div class="payment-retry-flow">
    <open-raptor-form [formData]="formData" [manager]="retryPaymentFlowManagerService"></open-raptor-form>
  </div>
</ng-container>

<ng-container *ngIf="isLoading">
  <div class="padding-xxbig flex flex-justify-center">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</ng-container>
